import { Trigger } from "@radix-ui/react-dropdown-menu";
import { cx } from "class-variance-authority";
import React, { MutableRefObject } from "react";
import { FiChevronDown } from "react-icons/fi";
import { HStack } from "../../composition/stack.layout";
import { invalidInputOutlineClasses } from "../../input-general/validation";
import { SelectOption } from "../types";

const MULTISELECT_TRIGGER_CLASSES = cx(
  "flex border-dublin-gray justify-between items-center focus:outline-none focus:border-flo-magenta" +
    " focus:ring-flo-magenta focus:ring-1 text-base rounded border px-4 py-2 space-x-1",
);
const MULTISELECT_VALUE_CLASSES =
  "bg-friendly-eskimo rounded text-sm px-1";
const MULTISELECT_PLACEHOLDER_CLASSES = "text-macbook";

interface BasicMultiTriggerProps {
  values: Array<SelectOption>;
  placeholder?: string;
  validation?: boolean;
}

const Base = React.forwardRef((props: BasicMultiTriggerProps, ref) => {
  const validValues = props.values.filter((value) => value.value !== "");
  return (
    <div
      role="button"
      tabIndex={0}
      className={cx(
        MULTISELECT_TRIGGER_CLASSES,
        props.validation && invalidInputOutlineClasses,
      )}
      ref={ref as MutableRefObject<HTMLDivElement>}
    >
      {validValues?.length > 0 ? (
        <HStack className={"space-x-1 truncate"}>
          {validValues.map((x) => {
            return (
              <span key={x.key} className={MULTISELECT_VALUE_CLASSES}>
                {x.label}
              </span>
            );
          })}
        </HStack>
      ) : (
        <span className={MULTISELECT_PLACEHOLDER_CLASSES}>
          {props.placeholder}
        </span>
      )}
      <span>
        <FiChevronDown size={20} className={""} />
      </span>
    </div>
  );
});

const BasicMultiSelectTrigger = (props: BasicMultiTriggerProps) => {
  return (
    <Trigger asChild>
      <Base {...props} />
    </Trigger>
  );
};

export const BasicMultiSelectTriggerForVirtualizedSelect = (
  props: BasicMultiTriggerProps,
) => {
  return <Base {...props} />;
};
